/**
 * Mega Menu Dynamic Carousel Engine
 * Initialise chaque carrousel avec drag, autoscroll et smooth wheel
 */
(function() {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var track   = root.querySelector('[data-track]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var bar     = root.querySelector('[data-bar]');
    if(!track) return;

    var rootId = root.id;
    var enableAutoScroll = root.getAttribute('data-autoscroll') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '5', 10) / 10;

    window.mmcsAnimations = window.mmcsAnimations || {};
    if (window.mmcsAnimations[rootId]) cancelAnimationFrame(window.mmcsAnimations[rootId]);
    if (window.mmcsAnimations[rootId + '_wheel']) cancelAnimationFrame(window.mmcsAnimations[rootId + '_wheel']);

    if (enableAutoScroll) track.style.scrollSnapType = 'none';

    var exactScrollLeft = track.scrollLeft;
    var isHovered = false;
    var isDown = false;
    var isAnimatingWheel = false;
    var scrollDirection = 1;
    var momentumTimer;
    var isWaitingForMomentum = false;

    function holdMomentum() {
      isWaitingForMomentum = true;
      clearTimeout(momentumTimer);
      momentumTimer = setTimeout(function() {
        isWaitingForMomentum = false;
        exactScrollLeft = track.scrollLeft;
        if(!enableAutoScroll) track.style.scrollSnapType = 'x mandatory';
      }, 150);
    }

    root.addEventListener('mouseenter', function(){ isHovered = true; });
    root.addEventListener('mouseleave', function(){ isHovered = false; });
    
    track.addEventListener('touchstart', function(){ 
      isDown = true; 
      track.style.scrollSnapType = 'none';
      holdMomentum();
    }, {passive:true});

    track.addEventListener('touchend', function(){ 
      isDown = false;
      holdMomentum();
    });

    /* --- DRAG LOGIC --- */
    var startX, scrollLeftStart, hasDragged = false;

    track.addEventListener('mousedown', function(e) {
      isDown = true;
      hasDragged = false;
      isAnimatingWheel = false; 
      track.classList.add('is-dragging');
      track.style.scrollSnapType = 'none';
      startX = e.pageX - track.offsetLeft;
      scrollLeftStart = track.scrollLeft;
    });

    track.addEventListener('mouseleave', function() {
      if(!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      holdMomentum();
    });

    track.addEventListener('mouseup', function() {
      isDown = false;
      track.classList.remove('is-dragging');
      holdMomentum();
    });

    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5; 
      if (Math.abs(walk) > 5) hasDragged = true; 
      track.scrollLeft = scrollLeftStart - walk;
      exactScrollLeft = track.scrollLeft;
      holdMomentum();
    });

    track.addEventListener('click', function(e) {
      if (hasDragged) { e.preventDefault(); e.stopPropagation(); }
    }, { capture: true });

    function bindContentDragPrevention() {
      track.querySelectorAll('img, a').forEach(function(el) {
        if (el.dataset.mmDragBound === 'true') return;
        el.dataset.mmDragBound = 'true';
        el.addEventListener('dragstart', function(e) { e.preventDefault(); });
      });
    }
    bindContentDragPrevention();

    /* --- SMOOTH WHEEL --- */
    var targetScroll = track.scrollLeft;
    var wheelSnapTimeout;

    function smoothWheel() {
      if (!isAnimatingWheel || isDown) return;
      var diff = targetScroll - track.scrollLeft;
      if (Math.abs(diff) > 1) {
        track.scrollLeft += diff * 0.12; 
        exactScrollLeft = track.scrollLeft;
        window.mmcsAnimations[rootId + '_wheel'] = requestAnimationFrame(smoothWheel);
      } else {
        track.scrollLeft = targetScroll;
        exactScrollLeft = track.scrollLeft;
        isAnimatingWheel = false;
      }
    }

    track.addEventListener('wheel', function(e) {
      holdMomentum();
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        isAnimatingWheel = false; 
        exactScrollLeft = track.scrollLeft;
        return; 
      }
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      var isAtStart = track.scrollLeft <= 0 && e.deltaY < 0;
      var isAtEnd = track.scrollLeft >= max - 1 && e.deltaY > 0;
      if (isAtStart || isAtEnd) { isAnimatingWheel = false; return; }

      e.preventDefault(); 
      track.style.scrollSnapType = 'none';
      if (!isAnimatingWheel) targetScroll = track.scrollLeft;
      
      targetScroll += e.deltaY * 1.8; 
      targetScroll = Math.max(0, Math.min(targetScroll, max)); 

      if (!isAnimatingWheel) { isAnimatingWheel = true; smoothWheel(); }

      clearTimeout(wheelSnapTimeout);
      wheelSnapTimeout = setTimeout(function() {
        if (!enableAutoScroll) track.style.scrollSnapType = 'x mandatory'; 
        exactScrollLeft = track.scrollLeft;
      }, 300);
    }, { passive: false });

    /* --- ARROWS --- */
    function cardWidth(){
      var card = track.querySelector('[data-card]');
      if(!card) return 0;
      var g = parseFloat(getComputedStyle(track).columnGap || 0);
      return card.getBoundingClientRect().width + g;
    }
    
    function goDir(dir){
      isAnimatingWheel = false; 
      track.scrollBy({ left: dir * cardWidth(), behavior: 'smooth' });
      holdMomentum();
    }
    if(prevBtn) prevBtn.addEventListener('click', function(){ goDir(-1); });
    if(nextBtn) nextBtn.addEventListener('click', function(){ goDir(1); });

    /* --- PROGRESS BAR --- */
    function setProgress(){
      if(!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? (track.scrollLeft / max) * 100 : 0;
      bar.style.setProperty('--prog', p + '%');

      if (!isAnimatingWheel) {
         clearTimeout(momentumTimer);
         momentumTimer = setTimeout(function() {
           isWaitingForMomentum = false;
           exactScrollLeft = track.scrollLeft;
         }, 80); 
      }
    }
    track.addEventListener('scroll', setProgress, { passive:true });
    window.addEventListener('resize', setProgress);
    setTimeout(setProgress, 60);

    /* Keep one carousel instance when a dynamic menu replaces its cards. */
    root.addEventListener('mm-carousel:refresh', function() {
      if (window.mmcsAnimations[rootId + '_wheel']) {
        cancelAnimationFrame(window.mmcsAnimations[rootId + '_wheel']);
      }
      clearTimeout(momentumTimer);
      clearTimeout(wheelSnapTimeout);
      isDown = false;
      isAnimatingWheel = false;
      isWaitingForMomentum = false;
      hasDragged = false;
      scrollDirection = 1;
      exactScrollLeft = 0;
      targetScroll = 0;
      track.scrollLeft = 0;
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = enableAutoScroll ? 'none' : 'x mandatory';
      bindContentDragPrevention();
      setProgress();
    });

    /* --- AUTOSCROLL --- */
    if (enableAutoScroll) {
      function autoLoop(){
        var max = track.scrollWidth - track.clientWidth;
        // Seulement autoscroll si le menu est visible (évite que ça tourne caché)
        if (root.offsetParent !== null && !isHovered && !isDown && !isAnimatingWheel && !isWaitingForMomentum) {
          if (max > 0) {
            exactScrollLeft += (speed * scrollDirection);
            if (exactScrollLeft >= max) { exactScrollLeft = max; scrollDirection = -1; } 
            else if (exactScrollLeft <= 0) { exactScrollLeft = 0; scrollDirection = 1; }
            track.scrollLeft = exactScrollLeft;
          }
        } else {
          exactScrollLeft = track.scrollLeft;
          if (exactScrollLeft >= max - 1) scrollDirection = -1;
          else if (exactScrollLeft <= 1) scrollDirection = 1;
        }
        window.mmcsAnimations[rootId] = requestAnimationFrame(autoLoop);
      }
      setTimeout(function() {
        exactScrollLeft = track.scrollLeft;
        window.mmcsAnimations[rootId] = requestAnimationFrame(autoLoop);
      }, 800);
    }
  }

  /* --- INITIALIZATION LOOP --- */
  function bootAll() {
    document.querySelectorAll('[data-mm-carousel]').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') bootAll();
  else document.addEventListener('DOMContentLoaded', bootAll);

  // Écoute les ouvertures de tiroir/menu pour s'assurer que le script s'active
  document.addEventListener('toggle', function(e) {
    if (e.target.tagName === 'DETAILS' && e.target.open) setTimeout(bootAll, 50);
  }, true);

  // Pour l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', bootAll);
})();
